interface IFPPOptions {
	string: string;
}

const splitStringFromKebabCase = ({ string }: IFPPOptions) => {
	return string.split('-');
};

export default splitStringFromKebabCase;
